"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TariffPoint = function (_BaseClass) {
  _inherits(TariffPoint, _BaseClass);

  /**
   * Id
   * @type {string}
   */

  /**
   * Ident
   * @type {string}
   */

  /**
   * Beschreibung kurz
   * @type {string}
   */

  /**
   * Beschreibung lang
   * @type {string}
   */

  /**
   * Tarifversion
   * @type {date}
   */

  /**
   * Pv
   * @type {string}
   */

  /**
   * Art des Tarifpunktes
   * @type {string}
   */
  function TariffPoint() {
    _classCallCheck(this, TariffPoint);

    var _this = _possibleConstructorReturn(this, (TariffPoint.__proto__ || Object.getPrototypeOf(TariffPoint)).call(this));

    _this.Id = "";
    _this.Ident = "";
    _this.DescriptionShort = "";
    _this.DescriptionLong = "";
    _this.Version = "";
    _this.Pv = "";
    _this.TariffPointType = "";
    _this.ContractStart = "";
    return _this;
  }
  /**
   * Vertragsbeginn
   * @type {date}
   */


  return TariffPoint;
}(_BaseClass3.default);

exports.default = TariffPoint;